import { useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { SocialLinkItem } from "./SocialLinkItem";
import { IInput } from "./VerifyStep";
import { SocialIcon } from "components/UI/SocialIcon";
import { clsx } from "clsx";
import "./styles/SocialLinksForm.scss";

export interface updateInputData {
  value: string;
  validMessage: string | null;
}

interface ISocialLinksFormProps {
  handleUpdateInputs: (inputs: IInput[]) => void;
  inputList: IInput[];
  socialTabs: any[];
  handleUpdateSocialTabs: (socialTabs: any[]) => void;
  isProfile?: boolean;
}

export const SocialLinksForm = (props: ISocialLinksFormProps) => {
  const {
    handleUpdateInputs,
    inputList,
    socialTabs,
    handleUpdateSocialTabs,
    isProfile
  } = props;

  useEffect(() => {
    handleUpdateInputs(inputList);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputList]);

  const handleAddInput = ({ key, isRequired, placeholder, socialKey }: any) => {
    const newInput = {
      id: uuidv4(),
      name: key,
      value: "",
      validMessage: null,
      isRequired,
      placeholder,
      socialKey
    };
    const newInputList = [...inputList, newInput];

    handleUpdateInputs(newInputList);
  };

  const removeInput = (id: string, name: string) => {
    const newInputList = inputList.filter(input => input.id !== id);

    setSocialTabState(name);
    handleUpdateInputs(newInputList);
  };

  const updateInput = (id: string, inputToUpdateValues: updateInputData) => {
    const updatedInput = inputList.map((input) => input.id === id ? { ...input, ...inputToUpdateValues } : { ...input });

    handleUpdateInputs(updatedInput);
  };

  const toggleSocialTab = (
    isSelected: boolean,
    { key, isRequired, placeholder, socialKey }: any
  ) => {
    const inputId = inputList.find(input => input.name === key)?.id;

    if (!isSelected) {
      handleAddInput({
        key,
        isRequired,
        placeholder,
        socialKey
      });
    } else {
      // @ts-ignore
      removeInput(inputId);
    }

    setSocialTabState(key);
  };

  const setSocialTabState = (key: string) => {
    const updatedSocials = socialTabs.map(([keyValue, { isSelected, ...rest }]) => {
      if (keyValue === key) {
        return [keyValue, { ...rest, isSelected: !isSelected }];
      }
      return [keyValue, { ...rest, isSelected }];
    });

    handleUpdateSocialTabs(updatedSocials);
  };

  const renderSocialBtn = ([key, { isSelected, ...rest }]: any) => {
    return (
      <li
        key={key}
        className={clsx(
          "SocialLinksForm-ListSocialItem",
          isSelected && "SocialLinksForm-ListSocialItem_isSelected"
        )}
        onClick={() => toggleSocialTab(isSelected, { key, ...rest })}
      >
        <button type="button">
          <SocialIcon name={key} />
        </button>
      </li>
    );
  };

  const renderInputsList = ({ title, isReq }: any) => (
    <div className="SocialLinksForm-List">
      <h3 className="SocialLinksForm-ListTitle">{title}</h3>
      <p className="SocialLinksForm-ListDescription">Click a  logo to add your personal link</p>
      <ul className="SocialLinksForm-ListSocials">
        {socialTabs.filter(([key, { isRequired }]) => isRequired === isReq).map(renderSocialBtn)}
      </ul>
      {inputList
        .filter(({ isRequired }) => isRequired === isReq)
        .map((input) => (
          <SocialLinkItem
            updateInput={updateInput}
            removeInput={removeInput}
            key={input.id}
            {...input}
          />
        ))}
    </div>
  );

  const renderGeneralInputs = () => (
    <div className="SocialLinksForm-List">
      <p className="SocialLinksForm-ListDescription">Click a  logo to add your personal link</p>
      <ul className="SocialLinksForm-ListSocials">{socialTabs.map(renderSocialBtn)}</ul>
      {inputList.map((input) => (
        <SocialLinkItem
          updateInput={updateInput}
          removeInput={removeInput}
          key={input.id}
          {...input}
        />
      ))}
    </div>
  );

  const renderRequiredInputs = renderInputsList({
    title: "Required Links (minimum 1)",
    isReq: true
  });

  const renderOptionalInputs = renderInputsList({
    title: "Optional Links",
    isReq: false
  });

  const renderInputs = () => {
    if (isProfile) {
      return renderGeneralInputs();
    }

    return (
      <>
        {renderRequiredInputs}
        {renderOptionalInputs}
      </>
    );
  };

  return (
    <div className="SocialLinksForm">
      {renderInputs()}
    </div>
  );
};
